import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Desplaza la ventana al inicio
    }, [pathname]);

    return null; // Este componente no renderiza nada en la UI
};
